export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-align-justify-58d2d2abb5d70bd566861b79eedfdc9e.svg";